import React from 'react';
import clsx from 'clsx';

import { Button } from '../..';
import { FirstPageIcon } from '../../icons/firstPageIcon/FirstPageIcon';
import { PrevPageIcon } from '../../icons/prevPageIcon/PrevPageIcon';

import { useStyles } from './DataGridPaginationActions.styles';
import { DataGridPaginationActionsProps } from './DataGridPaginationActions.types';

export const DataGridPaginationActions = ({
  count,
  page,
  rowsPerPage,
  onChangePage,
}: DataGridPaginationActionsProps) => {
  const classes = useStyles();
  const lastPage = Math.max(0, Math.ceil(count / rowsPerPage));

  const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onChangePage(event, page - 1);
  };

  const handlePageClick = (page: number) => (event: React.MouseEvent<HTMLButtonElement>) => {
    onChangePage(event, page);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onChangePage(event, lastPage - 1);
  };

  const currentPage = page + 1;

  return (
    <div className={classes.container}>
      <Button onClick={handleFirstPageButtonClick} className={classes.button}>
        <FirstPageIcon className={classes.icon} />
      </Button>
      {currentPage - 1 > 0 && (
        <>
          <Button onClick={handleBackButtonClick} className={classes.button}>
            <PrevPageIcon className={classes.icon} />
          </Button>
          <Button onClick={handlePageClick(page - 1)} className={classes.button}>
            {currentPage - 1}
          </Button>
        </>
      )}
      <Button onClick={handlePageClick(page)} className={clsx(classes.button, classes.currentPage)}>
        {currentPage}
      </Button>
      {currentPage + 1 <= lastPage && (
        <>
          <Button onClick={handlePageClick(page + 1)} className={classes.button}>
            {currentPage + 1}
          </Button>
          <Button onClick={handleNextButtonClick} className={classes.button}>
            <PrevPageIcon className={clsx(classes.icon, classes.rotateIcon)} />
          </Button>
        </>
      )}
      <Button onClick={handleLastPageButtonClick} className={classes.button}>
        <FirstPageIcon className={clsx(classes.icon, classes.rotateIcon)} />
      </Button>
    </div>
  );
};
